<template>
  <div class="table-content">
    <!-- <div class="header">
      <div class="headerLeft">
        <div class="filiale">
          <el-select v-model="value" :popper-append-to-body="false" size="small" @change="onSelectedDrug" filterable
            collapse-tags placeholder="请选择用户类别">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              <span class="check" />
              <span style="margin-left: 0.08rem;">{{ item.label }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="startDate">
          <el-date-picker v-model="date1" size="small" type="datetime" @change="getSTime1" placeholder="开始日期时间(申请)"
            :picker-options="getSTime1Fun">
          </el-date-picker>
        </div>
        <div class="endDate">
          <el-date-picker v-model="date2" size="small" type="datetime" @change="getSTime2" placeholder="结束日期时间(申请)"
            :picker-options="getSTime2Fun">
          </el-date-picker>
        </div>
      </div>
      <div class="fun">
        <el-row>
          <el-button class="search" size="mini" @click="search()">搜索</el-button>
          <el-button class="deltale" size="mini" @click="deltale()">清除</el-button>
          <el-button class="doexcel" size="mini" @click="doexcel()">导出</el-button>
        </el-row>
      </div>
    </div> -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="客户类型" width="180">
        <template slot-scope="scope">
          <span style="">{{ scope.row.type }}</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名" width="180">
        <template slot-scope="scope">
          <el-popover placement="top">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium">{{ scope.row.name }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="身份证" width="180">
        <template slot-scope="scope">
          <span style="">{{ scope.row.idCard }}</span>
        </template>
      </el-table-column>
      <el-table-column label="联系方式" width="180">
        <template slot-scope="scope">
          <span style="">{{ scope.row.telPhone }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请额度" width="180">
        <template slot-scope="scope">
          <span style="">{{ scope.row.limit }}</span>
        </template>
      </el-table-column>
      <el-table-column label="申请时间" width="180">
        <template slot-scope="scope">
          <span style="">{{ scope.row.date }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button class="successOperate"  size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">通过</el-button>
          <el-button class="dangerOperate" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">未通过</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="isPage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage1" :page-size="15" layout=" prev, pager, next" :total="totalCount">
      </el-pagination>
      <div class="pagNum">共{{pagNum}}页 （共{{totalCount}}条）</div>
    </div>
  </div>
</template>
<script>
import { MessageBox } from 'element-ui';
  export default {
    name: "venusZone1", //审批流程
    data() {
      return {
        tableData: [{
          type: '个人',
          name: '王小虎1',
          idCard: '1456787654341',
          telPhone: '1456776545',
          limit: '500万',
          date: '2016-05-02',
        }, {
          type: '个人',
          name: '王小虎2',
          idCard: '1456787654342',
          telPhone: '1456776545',
          limit: '500万',
          date: '2016-05-02',
        }, {
          type: '个人',
          name: '王小虎3',
          idCard: '1456787654343',
          telPhone: '1456776545',
          limit: '500万',
          date: '2016-05-02',
        }, {
          type: '个人',
          name: '王小虎4',
          idCard: '1456787654344',
          telPhone: '1456776545',
          limit: '500万',
          date: '2016-05-02',
        }],
        paginations: {
          pageIndex: 1, // 当前位于哪页
          pageSize: 15, // 1页显示多少条
          pageSizes: [5, 10, 15, 20], //每页显示多少条
          layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
        },
        currentPage1: 1,
        options: [{
          value: '',
          label: '全部客户'
        }, {
          value: '1',
          label: '个人'
        }, {
          value: '2',
          label: '企业'
        }],
        value: [],
        date1: '', //开始日期
        date2: '', //结束日期
        isPage: true,
        token: "",
        pagNum: "", //总页数
        pageNumber: 1, //页码数
        pageSize: 15, //每页条数
        totalCount: "", //总条数
        startTime: "", //开始时间
        endTime: "", //结束时间
        selectData: [], //导出excel文件
        excelData: [],
        userTypeName: "", //客户类型
        userType: "", //客户类型id
        //请求参数
        req: {
          startTime1: "", //开始时间
          endTime1: "", //结束时间
          userType1: "", //客户类型id
        },
        //设置日历可选择日期
        getSTime1Fun: {
          disabledDate: (time) => {
            if (this.date2) return time.getTime() > this.date2
            else return
          }
        },
        getSTime2Fun: {
          disabledDate: (time) => {
            if (this.date1) return time.getTime() < this.date1
            else return
          }
        },
        operateStatus:"",//操作按钮变化,1为通过，2为未通过
        realDepositNum:"",//实际存款额度
        applicaMsg:"",//获取申请人信息
      }
    },
    props: {},
    created() {
      this.token = sessionStorage.getItem('token');
      console.log("this.aasd", this.token)
      this.firstSearch(); //首次进入页面加载所有数据
    },
    mounted() {},
    methods: {
      //操作按钮
      handleEdit(index, row) {//通过按钮
        console.log(index, row);
        if(btnText=="已处理"){
          return
        }
        //获取每一条信息的操作按钮
        let successOperateS=document.getElementsByClassName("successOperate")
        let dangerOperateS=document.getElementsByClassName("dangerOperate")
        //提示弹框
        let btnText=successOperateS[index].innerText;
        console.log("btnText",btnText)
        //获取申请人信息
        this.applicaMsg=this.tableData[index].idCard;
        console.log("applicaMsg",this.applicaMsg)
        //将操作结果传给后台
        this.operateStatus="1";
        this.open();
        //点击未通过按钮后调整操作模块样式
        successOperateS[index].innerHTML=`<el-button size="mini" type="info">已处理</el-button>`
        dangerOperateS[index].style.display="none"
      },
      handleDelete(index, row) {//未通过按钮
        console.log(index, row);
        if(btnText=="已处理"){
          return
        }
        //获取每一条信息的操作按钮
        let successOperateS=document.getElementsByClassName("successOperate")
        let dangerOperateS=document.getElementsByClassName("dangerOperate")
        //提示弹框
        let btnText=dangerOperateS[index].innerText;
        console.log("btnText",btnText)
        if(btnText!="已处理"){
          this.$alert('操作成功', '提示', {
            confirmButtonText: '确定',
            callback: action => {}
          });
        }
        //点击未通过按钮后调整操作模块样式
        successOperateS[index].style.display="none"
        dangerOperateS[index].innerHTML=`<el-button size="mini" type="info">已处理</el-button>`
        dangerOperateS[index].style.marginLeft="0"
        //将操作结果传给后台
        this.operateStatus="2";
        // this.getOperateStatus();
      },
      //上送操作动作及用户信息
      getOperateStatus(){
        let url = ''//上传操作结果接口
        let params={
          operatestatus:this.operateStatus,//审核结果
          realDepositNum:this.realDepositNum,//实际存款额度
          applicaMsg:this.applicaMsg,//申请人信息
        }
        console.log("操作结果",this.operateStatus,params)
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("上传成功",)
          }
        }, );
      },
      //输入用户实际存款金额
      open() {
        this.$prompt('请输入真实存款金额（单位/万元）', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^\d{1,}$/,
          inputErrorMessage: '输入格式不正确'
        }).then(({ value }) => {
          this.$message({
            type: 'success',
            message: '您输入的金额是: ' + value + "万元"
          });
          this.realDepositNum=value;
          console.log("this.realDeposit",this.realDepositNum)
          this.getOperateStatus();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
      },
      //条数转页数
      pagNumS() {
        let pages = Math.ceil(this.totalCount / 15)
        this.pagNum = pages;
        console.log("aaaa", this.pagNum)
      },
      // 上下分页 pageIndex
      handleCurrentChange(page) {
        let params = {
          startTime: this.req.startTime1, //开始时间
          endTime: this.req.endTime1, //结束时间
          token: this.token,
          pageNumber: this.currentPage1,
          pageSize: this.pageSize,
          userType: this.req.userType1, //用户类型
        };
        console.log("bbbbbbbbb", params)
        let _this = this;
        let url = '/ft-oms/eventController/selectEvent.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.eventRes
            this.totalCount = parseInt(res.data.data.totalCount)
            this.pagNumS();
          } else if (res.data.code == "99999") {
            if (res.data.data.code == '88886') {
              this.$router.push({
                path: "/login"
              })
            } else {
              this.tableData = [];
              this.isPage = false
            }
          } else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      // 每页多少条切换 pageSize
      handleSizeChange(page_size) {

      },
      //查询用户类别ID
      onSelectedDrug(id) {
        let obj = {};
        obj = this.options.find((item) => {
          return item.value === id; //筛选出匹配数据
        })
        console.log("用户", id); //获取的 id
        // console.log(obj.label); //获取的名称
        this.userTypeName = obj.label;
        this.userType = id;
      },
      //获取开始日期
      getSTime1(val1) {
        this.date1 = val1
        console.log(this.date1)
        var d = new Date(this.date1);
        var youWant = d.getFullYear() + '/' + (d.getMonth() + 1) + '/' + d.getDate() + ' ' + d.getHours() + ':' + d
          .getMinutes() + ':' + d.getSeconds();
        console.log(youWant)
        if (youWant == "1970/1/1 8:0:0") {
          youWant = ""
        }
        this.startTime = youWant
        console.log("this.startTime", this.startTime)
        // this.endTime = youWant2
      },
      //获取结束日期
      getSTime2(val2) {
        this.date2 = val2
        var d2 = new Date(this.date2);
        var youWant2 = d2.getFullYear() + '/' + (d2.getMonth() + 1) + '/' + d2.getDate() + ' ' + d2.getHours() + ':' +
          d2.getMinutes() + ':' + d2.getSeconds();
        console.log(youWant2)
        if (youWant2 == "1970/1/1 8:0:0") {
          youWant2 = ""
        }
        // this.startTime = youWant
        this.endTime = youWant2
        console.log("this.endTime", this.endTime)

      },
      
      //首次进入加载数据
      firstSearch() {
        let params = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          startTime: "", //开始时间
          endTime: "", //结束时间
          token: this.token,
          userType: "", //用户类型
        };
        let _this = this;
        let url = '/ft-oms/eventController/selectEvent.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.eventRes
            this.totalCount = parseInt(res.data.data.totalCount)
            this.pagNumS();
            this.isPage = true
          } else if (res.data.code == "99999") {
            if (res.data.data.code == '88886') {
              this.$router.push({
                path: "/login"
              })
            } else {
              this.tableData = [];
              this.isPage = false
            }
          } else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      //搜索
      search() {
        console.log("开始时间", this.startTime)
        console.log("结束时间", this.endTime)
        if ((this.startTime != '' && this.endTime != '') || (this.startTime == '' && this.endTime == '')) {
          let params = {
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
            startTime: this.startTime, //开始时间
            endTime: this.endTime, //结束时间
            token: this.token,
            userType: this.userType, //用户类型
          };

          this.req.startTime1 = params.startTime
          this.req.endTime1 = params.endTime
          this.req.userType1 = params.userType

          let _this = this;
          let url = '/ft-oms/eventController/selectEvent.action'
          this.$http.post(url, params).then(res => {
            if (res.data.code == "200") {
              console.log("data1===", res.data.data)
              this.tableData = res.data.data.eventRes
              this.totalCount = parseInt(res.data.data.totalCount)
              this.currentPage1 = 1
              this.pagNumS();
              this.isPage = true
            } else if (res.data.code == "99999") {
              if (res.data.data.code == '88886') {
                this.$router.push({
                  path: "/login"
                })
              } else {
                this.tableData = [];
                this.isPage = false
              }
            } else {
              this.tableData = [];
              this.isPage = false
            }
          }, );
        } else {
          this.$alert('请选择开始日期或结束日期', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {
              // this.$message({
              // type: 'info',
              // message: `action: ${ action }`
              // });
            }
          });
        }
      },
      //清除
      deltale() {
        this.value = ""
        this.date1 = "";
        this.date2 = "";
        this.startTime = "";
        this.endTime = "";
      },
      //导出
      doexcel() {
        let params = {
          startTime: this.req.startTime1, //开始时间
          endTime: this.req.endTime1, //结束时间
          token: this.token,
          userType: this.req.userType1, //用户类型
        };
        let _this = this;
        let url = '/ft-oms/eventController/selectEventExport.action'
        this.$http.post(url, params, {
          responseType: 'blob'
        }).then(res => {
          if (res.data.code == "99999") {
            if (res.data.data.code == '88886') {
              this.$router.push({
                path: "/login"
              })
            }
          } else {
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            }); // res就是接口返回的文件流了
            let objectUrl = URL.createObjectURL(blob);
            window.location.href = objectUrl;
          }
        }, );
      },
    }
  }

</script>

<style scoped>
  body {
    margin: 0;
  }

  .pagination {
    /* margin-bottom: 1.2rem; */
    margin-top: 1.2rem;
    display: flex;
    justify-content: center;
    height: 1.8rem;
    font-size: 0.9rem;
    line-height: 1.8rem;
    width: 100%;
  }

  .header {
    height: 3rem;
    display: flex;
    justify-content: space-between;
  }

  .filiale,
  .input {
    margin-right: 0.5rem;
  }

  .startDate,
  .endDate {
    margin-right: 0.5rem;
  }

  .search {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    /* height: 1.7rem;
    line-height: 1.7rem;
    width: 2.8rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #FF9D47;
    /* margin-right: 0.6rem; */
  }

  .deltale {
    border: 1px solid #7A7A7A;
    border-radius: 0.2rem;
    /* height: 1.7rem;
    line-height: 1.7rem;
    width: 2.8rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #7A7A7A;
    /* margin-right: 0.6rem; */
  }

  .doexcel {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    /* height: 1.7rem;
    line-height: 1.7rem;
    width: 2.8rem; */
    text-align: center;
    font-size: 0.6rem;
    color: #ffffff;
    background: #FF9D47;
  }

  .pagNum {
    margin-left: 1.2rem;
    margin-top: 0.2rem;
  }

  .checkboxImg {
    width: 4.8rem;
    height: 1.2rem;
    border: 1px solid #999999;
    background: url("../../../../static/img/sousuo-2.png") no-repeat center right;
  }

  .checkboxDiv {
    width: 4.8rem;
    display: none;
    border: 1px solid #999999;
    border-top: none;
  }

  .headerLeft {
    display: flex;
  }

  .fun {
    display: flex;
    /* margin-top: 1rem; */
    margin-bottom: 1rem;
    float: right;
  }

  .input {
    display: flex;
    border: 1px solid #dedede;
    width: 9rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.25rem;
    color: #bfcbd9;
  }

  .input input {
    flex: 9;
    border: 0;
    font-size: 0.8rem;
    width: 5rem;
    outline: none;
  }

  .input img {
    width: 50%;
    height: 50%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    flex: 1;
    margin-top: 0.4rem;
  }


  /*修改input框默认文本样式*/
  input::-webkit-input-placeholder {
    /* placeholder颜色 */
    color: #C1C1C1;
    /* placeholder字体大小 */
    /* font-size: 12px; */
  }

  .el-input__inner {
    height: 1.8rem;
    font-size: 0.72rem;
  }

  /*修改日期框样式*/
  .startDate>>>.el-date-editor {
    width: 12rem;
  }

  .startDate>>>.el-input__inner:focus {
    border-color: #FF9D47;
  }

  .endDate>>>.el-date-editor {
    width: 12rem;
  }

  .endDate>>>.el-input__inner:focus {
    border-color: #FF9D47;
  }

  /*修改下拉框样式*/
  .filiale>>>.el-input__inner {
    width: 10rem;
  }

  /* .el-select-dropdown__wrap {
    background: #b5879a !important;
  } */
  .filiale>>>.el-select .el-input.is-focus .el-input__inner {
    border-color: #FF9D47;
  }

  .filiale>>>.el-select .el-input__inner:focus {
    border-color: #FF9D47;

  }

  .el-select-dropdown__item.selected {
    color: #FF9D47;
  }

  .el-select-dropdown__item.hover {
    background-color: #ffffff;
  }

  .filiale>>>.el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: #FAF0E7;
    color: #FF9D47;
  }

  /*修改分页样式*/
  .pagination>>>.el-pager li.active {
    color: #FF9D47;
  }

  .pagination>>>.el-pager li:hover {
    color: #FF9D47;
  }

  .pagination>>>.el-icon-arrow-left:hover {
    color: #FF9D47;
  }

  .pagination>>>.el-icon-arrow-right:hover {
    color: #FF9D47;
  }

  .pagination>>>.el-icon-arrow-left.active {
    color: #FF9D47;
  }

  .pagination>>>.el-icon-arrow-right.active {
    color: #FF9D47;
  }

  .el-icon-arrow-left:hover {
    color: #FF9D47;
  }

  .el-icon-arrow-right:hover {
    color: #FF9D47;
  }

  .el-icon-arrow-left.active {
    color: #FF9D47;
  }

  .el-icon-arrow-right.active {
    color: #FF9D47;
  }

  .pagination>>>.el-pagination .btn-next:hover {
    color: #FF9D47;
  }

  .pagination>>>.el-pagination .btn-prev:hover {
    color: #FF9D47;
  }

  /*按钮样式*/
  .doexcel>>>.el-button--default .el-button--mini:hover {
    background-color: #FF9D47 !important;
    color: #ffffff;
    border-color: #FF9D47;
  }

  .search>>>.el-button--default .el-button--mini:hover {
    background-color: #ffffff !important;
    color: #FF9D47;
    border-color: #FF9D47;
  }

  .deltale>>>.el-button--default .el-button--mini:hover {
    background-color: #ffffff !important;
    color: #000;
    border-color: #000;
  }

  /*修改table样式*/
  .table-content>>>.el-table thead.is-group th {
    background-color: #ffffff;
  }

  .table-content>>>.el-table thead.is-group .is-leaf {
    background-color: #ffffff;
  }

  .table-content>>>.el-table thead.is-group th:first-child {
    /* color: salmon; */
    background: #ffaec9;
  }

  .table-content>>>.el-table thead.is-group th:nth-child(2) {
    background: #ffc90e;
  }

  .table-content>>>.el-table thead.is-group th:nth-child(3) {
    background: #efe4b0;
  }

  .table-content>>>.el-table thead.is-group th:nth-child(4) {
    background: #b5e61d;
  }

  .table-content>>>.el-table thead.is-group .is-leaf:nth-child(1) {
    color: #909399;
    background-color: #ffffff;
  }

  .table-content>>>.el-table thead.is-group .is-leaf:nth-child(2) {
    color: #909399;
    background-color: #ffffff;
  }

  .table-content>>>.el-table thead.is-group .is-leaf:nth-child(3) {
    color: #909399;
    background-color: #ffffff;
  }

  .table-content>>>.el-table thead.is-group .is-leaf:nth-child(4) {
    color: #909399;
    background-color: #ffffff;
  }

  .table-content>>>.el-table .cell {
    text-align: center;
  }

  /* .table-content>>>.el-table .staff{
    background: red;
    color: royalblue;
  } */
  /* .table-content>>>.el-table_29_column_320{
    text-align: center;
    background: chartreuse;
  }
  .table-content>>>.el-table_29_column_325{
    text-align: center;
    background: red;
  } */
  .filiale>>>.el-select-dropdown__wrap {
    max-height: 295px;
  }

</style>



// WEBPACK FOOTER //
// venusZone1.vue?9ad8c882